module.exports = __webpack_public_path__ + "img/itss.5cea00cb.png";